/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-02-08 15:41:01
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-06-02 09:46:30
 * @FilePath: \合联\oms\src\api\finance\halfPrice.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/quotation/unPod/rule",
    method: "get",
    params
  });
};

export const add = data => {
  return axios.request({
    url: "/quotation/unPod/rule",
    method: "post",
    data
  });
};

export const detail = id => {
  return axios.request({
    url: `/quotation/unPod/rule/${id}`,
    method: "get",
  });
};

export const update = data => {
  return axios.request({
    url: `/quotation/unPod/rule/${data.id}`,
    method: "put",
    data
  });
};

export const del = id => {
  return axios.request({
    url: `/quotation/unPod/rule/${id}`,
    method: "delete"
  });
};

export const config = (params) => {
  return axios.request({
    url: `/quotation/unPod/config`,
    method: "get",
    params
  });
};
export const configAdd = (data) => {
  return axios.request({
    url: `/quotation/unPod/config`,
    method: "post",
    data
  });
};
export const configUpdate = (data) => {
  return axios.request({
    url: `/quotation/unPod/config/` + data.id,
    method: "put",
    data
  });
};

export const configDetail = id => {
  return axios.request({
    url: `/quotation/unPod/config/${id}`,
    method: "get",
  });
};

export const configDel = id => {
  return axios.request({
    url: `/quotation/unPod/config/${id}`,
    method: "delete"
  });
};


